import { put, call, take, fork, select, race, delay } from "redux-saga/effects";
import Keycloak from "keycloak-js";
import detectBrowserLanguage from "detect-browser-language";
import Cookies from "universal-cookie";
import * as LoginActions from "./loginActions";
import * as Helpers from "../helpers";
import { requestTechnicians } from "../technician/technicianActions";
import { requestTasks, requestTasksForTechnician, requestAllStatus } from "../task/taskActions";
import { setLocaleLang } from "../domain/domainActions";
import { requestReasons, requestCompleteReasons } from "../reason/reasonActions";
import { requestContracts, requestSkills } from "../manageLabourer/manageLabourerActions";
import technicianServices from "./../../services/technicianServices";
import { requestAdditionalAction } from "../additionalAction/additionalActionActions";

import KeyCloakConf from "../../common/keycloak/keycloak.json";
import { requestFollowUpReasons } from "../followUps/followUpsActions";

export const watchLoginFlow = function* () {
    while (true) {
        yield take("REQUEST_LOGIN");
        yield fork(authenticate);

        yield take(["LOGOUT"]);
        yield call(logout);
        // ... perform the logout logic
    }
};

export function* watchPollTask() {
    while (true) {
        yield take("START_WATCHER_TASK");
        yield race([call(pollTask), take("STOP_WATCHER_TASK")]);
    }
}

export function* watchPollRefreshToken() {
    while (true) {
        yield take("START_WATCHER_REFRESH_TOKEN");
        yield race([call(pollRefreshToken), take("STOP_WATCHER_REFRESH_TOKEN")]);
    }
}

var authenticatedKeycloak = null;
const authenticate = function* () {
    const keycloak = Keycloak(KeyCloakConf);
    const cookies = new Cookies();
    const authenticated = yield call(keycloak.init, { onLoad: "login-required", checkLoginIframe: false });
    if (authenticated) {
        const userProfile = yield call(keycloak.loadUserProfile);
        const userInfo = yield call(keycloak.loadUserInfo);
        yield put(LoginActions.genToken(keycloak));
        const technicianInfo = yield Helpers.makeApiCall(technicianServices.getTechnician, userInfo.sub);

        let technician;
        if (!technicianInfo || technicianInfo.length <= 0) {
            technician = null;
        } else {
            technician = technicianInfo[0]; // should be 1 technician, so just grab first one for now
        }
        authenticatedKeycloak = keycloak;
        // Write auth info to the state object.
        // Derive role flags and persist on technician in Redux for easier access
        const isAdmin = keycloak.hasRealmRole("ContractorAdminRole");
        const isLabourer = keycloak.hasRealmRole("ContractorLabourerRole");
        const technicianWithRoles = { ...(technician || {}), isAdmin, isLabourer };
        yield put(LoginActions.authenticated(keycloak, userProfile, userInfo, technicianWithRoles));

        // Use technician preference if cookie doesn't exist. Use browser if no preference
        if (!cookies.get("locale")) {
            if (technician && technician.languagePreference) yield put(setLocaleLang(technician.languagePreference));
            else yield put(setLocaleLang(detectBrowserLanguage().substring(0, 2))); // Default to browser if undefined
        }

        // We are authenticated fetch data from REST sevices
        yield put(requestReasons());
        yield put(requestCompleteReasons());
        yield put(requestFollowUpReasons());
        yield put(requestAdditionalAction());
        yield put(requestContracts());
        yield put(requestAllStatus());
        yield put(requestSkills());
        yield put(LoginActions.startPolling());
        yield put(LoginActions.startRefreshPolling());
    }
};

const logout = function* () {
    yield clearLang();
    const keycloak = yield select(Helpers.getKeycloak);

    keycloak.logout();

    yield put(LoginActions.clearAuth());
};

const clearLang = () => {
    const cookies = new Cookies();
    // Clear language cookie on logout, as per FMSGAS-6626 (April 13 2021)
    cookies.remove("locale", { path: "/" });
};

function* pollRefreshToken() {
    while (true) {
        try {
            const keycloak = yield select(Helpers.getKeycloak);
            if (keycloak) {
                keycloak.updateToken(600).then(function (refreshed) {
                    if (refreshed) {
                        LoginActions.refreshToken(keycloak);
                    } else {
                        logout();
                    }
                });
            }

            // wait 10 mins
            yield delay(10 * 60 * 1000);
        } catch (err) {
            yield put(LoginActions.stopRefreshPolling());
        }
    }
}

function* pollTask() {
    // while (true) {
    try {
        if (authenticatedKeycloak && authenticatedKeycloak.hasRealmRole("ContractorAdminRole")) {
            // We are authenticated fetch data from REST sevices for Admin Role
            yield put(requestTechnicians());
            //yield put(requestTasks(true)); // true makes counts call

            // yield put(requestReasons())
        } else if (authenticatedKeycloak && authenticatedKeycloak.hasRealmRole("ContractorLabourerRole")) {
            // We are authenticated fetch tasks data from REST Servies for Labourer Role
            yield put(requestTasksForTechnician());
        }

        // wait 3 mins
        // yield delay(2 * 60 * 1000);
    } catch (err) {
        console.log(err);
        // Once the polling has encountered an error,
        // it should be stopped immediately
        yield put(LoginActions.stopPolling());
    }
    // }
}
